<div
    class="cmps-event-centre-c-pop-data--primary cmps-cdk-bg-color-blue-100 cmps-cdk-color-white cmps-cdk-py-0dot5 cmps-cdk-px-2 cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-justify-content-center cmps-cdk-align-items-center"
    *ngIf="_data?.style?.toLowerCase()?.trim() === 'primary'"
>
    <div class="cmps-event-centre-c-pop-data--primary-1 cmps-cdk-font-bold">
        {{ _data?.topValue }}
    </div>
    <div class="cmps-event-centre-c-pop-data--primary-2">
        {{ _data?.bottomValue }}
    </div>
</div>

<div
    class="cmps-event-centre-c-pop-data--secondary cmps-cdk-bg-color-white cmps-cdk-color-blue-100 cmps-cdk-py-0dot5 cmps-cdk-px-2 cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-justify-content-center cmps-cdk-align-items-center"
    *ngIf="_data?.style?.toLowerCase()?.trim() === 'secondary'"
>
    <div class="cmps-event-centre-c-pop-data--secondary-1 cmps-cdk-font-bold">
        {{ _data?.topValue }}
    </div>
    <div class="cmps-event-centre-c-pop-data--secondary-2">
        {{ _data?.bottomValue }}
    </div>
</div>
